<template>
  <header class="app-header">
    <router-link to="/" class="app-header__brand">
      <span class="app-header__mark" aria-hidden="true"></span>
      Enjoy Cooking
    </router-link>
    <nav class="app-header__nav">
      <span v-if="hat" class="app-header__hat" :title="`Meal Hat: ${hat}`">{{ hatLabel }}</span>
      <button v-if="email" type="button" class="app-header__link" @click="$emit('sign-out')">Sign out</button>
    </nav>
  </header>
</template>

<script>
// One bar. The brand goes home (an installed app has no back button), the
// hat name says whose kitchen this is, and sign out is there because
// households share iPads.
export default {
  name: 'AppHeader',
  props: {
    email: { type: String, default: null },
    hat: { type: String, default: null }
  },
  emits: ['sign-out'],
  computed: {
    hatLabel () {
      // mattgrosso-gmail-com → mattgrosso; a named shared hat stays as typed.
      return String(this.hat || '').replace(/-(gmail|yahoo|hotmail|icloud|outlook)-com$/, '');
    }
  }
};
</script>

<style scoped>
.app-header {
  align-items: center; display: flex; justify-content: space-between; gap: 1rem;
  padding: calc(var(--band-top) + 0.6rem) 1.25rem 0.6rem;
  border-bottom: 1px solid var(--line);
  background: var(--surface);
  position: sticky; top: 0; z-index: 50;
}
.app-header__brand { display: inline-flex; align-items: center; gap: 0.5rem; color: var(--text); font-weight: 800; text-decoration: none; letter-spacing: 0.01em; }
.app-header__mark { width: 0.8rem; height: 0.8rem; border-radius: 50%; background: var(--accent); display: inline-block; }
.app-header__nav { display: flex; align-items: center; gap: 1rem; }
.app-header__hat { color: var(--muted); font-size: 0.8rem; }
.app-header__link { background: none; border: 0; padding: 0; color: var(--muted); font-size: 0.85rem; cursor: pointer; }
.app-header__link:active { color: var(--text); }
</style>
